module.exports = __webpack_public_path__ + "icon-72x72.png";